const APP_INFO_ACTION_TYPES = {
  GET: {
    IN_PROGRESS: 'APP_INFO_IN_PROGRESS',
    SUCCESS: 'APP_INFO_SUCCESS',
    ERROR: 'APP_INFO_ERROR',
  },
};

export default APP_INFO_ACTION_TYPES;
